const isBankDocumentsDiagnosticsEnabled =
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_ENABLE_BANK_DOCUMENTS_LOGGER === 'true';

export const bankDocumentsLogger = {
  debug: (...args: unknown[]) => {
    if (isBankDocumentsDiagnosticsEnabled) {
      console.log(...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (isBankDocumentsDiagnosticsEnabled) {
      console.warn(...args);
    }
  },
  error: (...args: unknown[]) => {
    if (isBankDocumentsDiagnosticsEnabled) {
      console.error(...args);
    }
  },
};
